export default "__VITE_ASSET__DBdxiRIK__"